import React, { forwardRef } from 'react';
import { View, Text, Image, StyleSheet } from 'react-native';

// Target: 1200 × 675 px (rendered off-screen, 300dpi 4"×2.25")
const W = 1200;
const H = 675;

const ChildLabelView = forwardRef(function ChildLabelView({ data }, ref) {
  const {
    firstName = '',
    lastName = '',
    avatarUri = null,
    date = '',
    time = '',
    age = '',
    customfield1 = '',
    customfield2_line1 = '',
    customfield2_line2 = '',
    customfield3_line1 = '',
    customfield3_line2 = '',
    code = '',
    logoUri = null
  } = data || {};

  return (
    <View ref={ref} style={styles.root}>
      {/* Top section */}
      <View style={styles.topSection}>
        <View style={styles.nameBlock}>
          <Text style={styles.firstName} numberOfLines={1}>{firstName}</Text>
          <Text style={styles.lastName} numberOfLines={1}>{lastName}</Text>
        </View>
        {avatarUri ? (
          <Image key={avatarUri} source={{ uri: avatarUri }} style={styles.avatar} resizeMode="cover" />
        ) : (
          <View style={styles.avatarPlaceholder} />
        )}
      </View>

      {/* Divider 1 */}
      <View style={styles.divider} />

      {/* Middle section */}
      <View style={styles.middleSection}>
        <View style={styles.dateTimeBlock}>
          <Text style={styles.smallText}>{date}</Text>
          <Text style={styles.smallText}>{time}</Text>
        </View>
        <Text style={styles.ageText}>{customfield1 || age}</Text>
      </View>

      {/* Divider 2 */}
      <View style={styles.divider} />

      {/* Bottom section */}
      <View style={styles.bottomSection}>
        <View style={styles.codeBlockWrapper}>
          <View style={styles.codeBlock}>
            <Text style={styles.codeText}>{code}</Text>
          </View>
        </View>
        <View style={styles.customfield2Block}>
          <Text style={styles.customSmall}>{customfield2_line1}</Text>
          <Text style={styles.customSmall}>{customfield2_line2}</Text>
        </View>
        <View style={styles.customfield3Block}>
          <Text style={styles.customSmall}>{customfield3_line1}</Text>
          <Text style={styles.customSmall}>{customfield3_line2}</Text>
        </View>
      </View>

      {/* Logo */}
      {logoUri && (
        <Image source={{ uri: logoUri }} style={styles.logo} resizeMode="contain" />
      )}
    </View>
  );
});

const styles = StyleSheet.create({
  root: {
    width: W,
    height: H,
    backgroundColor: '#fff',
    paddingHorizontal: 28,
    paddingVertical: 18,
  },
  topSection: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: H * 0.37,
  },
  nameBlock: { flex: 1 },
  firstName: {
    fontSize: 84,
    fontWeight: '700',
    fontFamily: 'System',
    color: '#000',
  },
  lastName: {
    fontSize: 60,
    fontWeight: '400',
    fontFamily: 'System',
    color: '#000',
    marginTop: 4,
  },
  avatar: {
    width: 200,
    height: 160,
    borderRadius: 8,
    marginLeft: 16,
  },
  avatarPlaceholder: {
    width: 200,
    height: 160,
  },
  divider: {
    height: 2,
    backgroundColor: '#000',
    marginVertical: 8,
  },
  middleSection: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: H * 0.22,
  },
  dateTimeBlock: { flex: 1 },
  smallText: {
    fontSize: 36,
    color: '#000',
    fontFamily: 'System',
  },
  ageText: {
    fontSize: 36,
    color: '#000',
    fontFamily: 'System',
    textAlign: 'right',
  },
  bottomSection: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: 1,
    gap: 12,
    marginTop: 8,
  },
  codeBlockWrapper: {
    width: '33%'
  },
  codeBlock: {
    backgroundColor: '#000',
    borderRadius: 12,
    paddingHorizontal: 22,
    paddingVertical: 12,
    alignItems: 'center',
    justifyContent: 'center',
    width: 200,
    marginBottom:10,
  },
  codeText: {
    fontSize: 32,
    fontWeight: '700',
    color: '#fff',
    fontFamily: 'System',
  },
  customfield2Block: {
    flex: 1,
    alignItems: 'center',
    width: '33%'
  },
  customfield3Block: {
    flex: 1,
    alignItems: 'center',
    width: '33%'
  },
  customSmall: {
    fontSize: 30,
    color: '#000',
    fontFamily: 'System',
    textAlign: 'center',
  },
  logo: {
    position: 'absolute',
    bottom: 18,
    left: 28,
    width: 200,
    height: 80
  },
});

export default ChildLabelView;
